import { render, staticRenderFns } from "./CharacterCounter.vue?vue&type=template&id=1c0f7828"
import script from "./CharacterCounter.vue?vue&type=script&lang=ts"
export * from "./CharacterCounter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports